import { useQuery } from "react-query";
import { getActiveDebts, getComplianceRate, getDebtDistributionByPaymentType, getDebtsByPeriod, getOverdueDebts, getPaymentsHistoryByStudent, getStudentsWithMostDelays, getTotalPaymentsByPeriods, getTotalsLatesFees } from "../services/finance/reports";
import { PagedRequestType } from "../types/PagedResults";

export const useGetActiveDebtsQuery = (data: PagedRequestType) =>
  useQuery(
    ["getactivedebts-pagination", JSON.stringify(data)],
    () => getActiveDebts(data)
  );

export const useGetDebtsByPeriodQuery = (data: PagedRequestType) =>
  useQuery(
    ["getdebtsbyperiod-pagination", JSON.stringify(data)],
    () => getDebtsByPeriod(data)
  );

export const useGetOverdueDebtsQuery = (data: PagedRequestType) =>
  useQuery(
    ["getoverduedebts-pagination", JSON.stringify(data)],
    () => getOverdueDebts(data)
  );

export const useGetDebtDistributionByPaymentTypeQuery = (data: PagedRequestType) =>
  useQuery(
    ["getdebtdistributionbypaymenttype-pagination", JSON.stringify(data)],
    () => getDebtDistributionByPaymentType(data)
  );

export const useGetPaymentsHistoryByStudentQuery = (data: PagedRequestType) =>
  useQuery(
    ["getpaymentshistorybystudent-pagination", JSON.stringify(data)],
    () => getPaymentsHistoryByStudent(data)
  );

export const useGetTotalPaymentsByPeriodsQuery = (data: PagedRequestType) =>
  useQuery(
    ["gettotalpaymentsbyperiods-pagination", JSON.stringify(data)],
    () => getTotalPaymentsByPeriods(data)
  );

export const useGetComplianceRateQuery = (data: PagedRequestType) =>
  useQuery(
    ["getcompliancerate-pagination", JSON.stringify(data)],
    () => getComplianceRate(data)
  );

export const useGetTotalsLatesFeesQuery = (data: PagedRequestType) =>
  useQuery(
    ["gettotalslatesfees-pagination", JSON.stringify(data)],
    () => getTotalsLatesFees(data)
  );

export const useGetStudentsWithMostDelaysQuery = (data: PagedRequestType) =>
  useQuery(
    ["getstudentswithmostdelays-pagination", JSON.stringify(data)],
    () => getStudentsWithMostDelays(data)
  );